import React from 'react';
import ReactModal from 'react-modal';
import { mergeClasses } from '@griffel/react';

ReactModal.setAppElement('#root');

const UIScreenModal = ({ className, isOpen, onClose, children, from }) =>
{
	let portalClassName = mergeClasses('modal-portal screen-modal', className, isOpen ? 'is-opened' : '');
	let overlayClassName = mergeClasses('modal-overlay screen-modal', className);
	className = mergeClasses('modal screen-modal', className, from === '' || from === undefined ? 'is-start' : '');

	return (
		<ReactModal
			isOpen={isOpen}
			onRequestClose={onClose}
			className={className}
			portalClassName={portalClassName}
			overlayClassName={overlayClassName}
			closeTimeoutMS={300}
		>
			{children}
		</ReactModal>
	);
};

export default UIScreenModal;
